module.exports = __webpack_public_path__ + "img/style_4_pl.666c00c0.jpeg";